module.exports = __webpack_public_path__ + "static/fonts/OpenSans-SemiBold.729e6a0.woff";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-SemiBold.woff
// module id = uBdQ
// module chunks = 3